module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9PFmQ"))).then(() => parcelRequire('2KbAe'));